import { Action } from '@reduxjs/toolkit';

import type { SubmitStakePayload } from '../saga/staking/types';
import type { ReduxAction } from 'app/redux/types';

import { API, getAsyncThunk } from 'app/api';
import type { ResponseSuccessPayload } from 'app/api/utils/default-response-adapter';

import type { BigStakeDAO } from '../types/backend/bigStakes';

// ---

export const ADD_BIG_STAKE = 'BET_SLIP:ADD_BIG_STAKE';

type AddBigStakePayload = {
  requestPayload: SubmitStakePayload;
  stake: BigStakeDAO;
};

export type AddBigStake = ReduxAction<typeof ADD_BIG_STAKE, AddBigStakePayload>;

export const addBigStake = (payload: AddBigStakePayload): AddBigStake => ({
  type: ADD_BIG_STAKE,
  payload,
});

// ---

// TODO: должно уйти, когда reduced/bigStakes будет переписан на slice
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Payload = any;

type Response = Awaited<ReturnType<typeof API.stakes.getBigStakes>>;
export type FetchBigStakesSuccess = ReduxAction<
  string,
  Extract<Response, ResponseSuccessPayload<Payload>>
>;

export const fetchPendingBigStakes = getAsyncThunk(
  'BET_SLIP:FETCH_BIG_STAKES',
  API.stakes.getBigStakes,
);

// ---

export const SHOW_BIG_STAKE_INFO = 'BET_SLIP:SHOW_BIG_STAKE_INFO';

export type ShowBigStakeInfo = Action<typeof SHOW_BIG_STAKE_INFO>;

export const showBigStakeInfo = (): ShowBigStakeInfo => ({
  type: SHOW_BIG_STAKE_INFO,
});

// ---

export const HIDE_BIG_STAKE_INFO = 'BET_SLIP:HIDE_BIG_STAKE_INFO';

export type HideBigStakeInfo = Action<typeof HIDE_BIG_STAKE_INFO>;

export const hideBigStakeInfo = (): HideBigStakeInfo => ({
  type: HIDE_BIG_STAKE_INFO,
});

// ---

export const CLOSE_BIG_STAKE_BAR = 'BET_SLIP:CLOSE_BIG_STAKE_BAR';

export type CloseBigStakeBar = Action<typeof CLOSE_BIG_STAKE_BAR>;

export const closeBigStakeBar = (): CloseBigStakeBar => ({
  type: CLOSE_BIG_STAKE_BAR,
});
